export default __webpack_public_path__ + "static/media/AstronomyMercury_04.bd0dd557.png";